import React from 'react';

export const Row: React.FC = ({ children }) => {
    return <div style={{ display: 'flex' }}>{children}</div>;
};
